import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, App as AntApp } from 'antd';
import { AuthProvider } from './context/AuthContext';
import AppLayout from './components/AppLayout';
import LoginPage from './pages/LoginPage';
import CoursesPage from './pages/CoursesPage';
import ModulesPage from './pages/ModulesPage';
import LessonsPage from './pages/LessonsPage';
import PracticeLessonPage from './pages/PracticeLessonPage';
import ThoughtsPage from './pages/ThoughtsPage';
import ImagesPage from './pages/ImagesPage';
import UsersPage from './pages/UsersPage';
import BundlesPage from './pages/BundlesPage';
import YookassaPaymentsPage from './pages/YookassaPaymentsPage';
import CsatPage from './pages/CsatPage';

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#1677ff',
          borderRadius: 8,
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        },
        components: {
          Table: { headerBg: '#fafafa' },
          Modal: { titleFontSize: 16 },
        },
      }}
    >
      <AntApp>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route element={<AppLayout />}>
                <Route index element={<Navigate to="/courses" replace />} />
                <Route path="/courses" element={<CoursesPage />} />
                <Route path="/courses/:courseId/modules" element={<ModulesPage />} />
                <Route
                  path="/courses/:courseId/modules/:moduleId/lessons"
                  element={<LessonsPage />}
                />
                <Route
                  path="/courses/:courseId/modules/:moduleId/lessons/:lessonId/practice"
                  element={<PracticeLessonPage />}
                />
                <Route path="/bundles" element={<BundlesPage />} />
                <Route path="/thoughts" element={<ThoughtsPage />} />
                <Route path="/images" element={<ImagesPage />} />
                <Route path="/users" element={<UsersPage />} />
                <Route path="/yookassa-payments" element={<YookassaPaymentsPage />} />
                <Route path="/csat" element={<CsatPage />} />
              </Route>
              <Route path="*" element={<Navigate to="/courses" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </AntApp>
    </ConfigProvider>
  );
}

export default App;
